import {Base} from "@/api/Base"

export class SalaryGeneralSalary extends Base {
    path = "salary/generalSalary"
}